import React from 'react';
import { DragPreviewContext } from './dragPreviewContext';

export default function DragPreviewProvider({
  value,
  children,
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return <DragPreviewContext.Provider value={value}>{children}</DragPreviewContext.Provider>;
}
